<template>
  <div>
    <div class="child-bg-image">
      <div class="bg-image-section" />
      <div class="content-section">
        <check-in-check-out-page />
        <check-in-page-history />
      </div>
    </div>
  </div>
</template>

<script>
import CheckInCheckOutPage from '../Components/CheckInPage.vue';
import CheckInPageHistory from '../Components/CheckInPageHistory.vue';
    export default {
        name: 'CheckIn',
        components: {
            'check-in-check-out-page': CheckInCheckOutPage,
            'check-in-page-history': CheckInPageHistory,
        },
    };
</script>

<style scoped>

</style>
